(() => {
  if (window.otdProductPageReady) return;
  window.otdProductPageReady = true;

  // Preserve every description node and link; progressively group existing copy.
  function enhanceDetails(scope = document) {
    scope.querySelectorAll('[data-otd-description]').forEach(source => {
      if (source.dataset.enhanced) return;
      source.dataset.enhanced = 'true';
      let content = source;
      while (content.children.length === 1 && content.firstElementChild.tagName === 'DIV' && !content.firstElementChild.id && Array.from(content.childNodes).every(n => n === content.firstElementChild || !n.textContent.trim())) content = content.firstElementChild;
      const groups = [];
      let group = {title: 'Overview', nodes: []};
      Array.from(content.childNodes).forEach(node => {
        if (node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName)) {
          if (group.nodes.some(n => n.textContent.trim() || n.nodeType === 1 && (n.matches('img,video,iframe') || n.querySelector('img,video,iframe')))) groups.push(group);
          const heading = node.textContent.trim();
          group = {title: heading === 'Fits' ? 'Compatibility' : heading, nodes: []};
        } else group.nodes.push(node);
      });
      if (group.nodes.length) groups.push(group);
      const fragment = document.createDocumentFragment();
      groups.forEach((item, index) => {
        if (!item.nodes.some(n => n.textContent.trim() || n.nodeType === 1 && (n.matches('img,video,iframe') || n.querySelector('img,video,iframe')))) return;
        const details = document.createElement('details');
        details.className = 'otd-product-detail';
        details.open = index === 0;
        const summary = document.createElement('summary');
        summary.textContent = item.title || 'Product information';
        const body = document.createElement('div');
        body.className = 'otd-product-detail__content rte';
        body.append(...item.nodes);
        details.append(summary, body);
        fragment.append(details);
      });
      if (fragment.childNodes.length) source.replaceWith(fragment);
    });
  }

  function enhanceProduct(product) {
    if (product.dataset.otdReady) return;
    product.dataset.otdReady = 'true';
    const info = product.querySelector('.main-product-info-container');
    // Keep the relocated review heading clear of the floating site header.
    const openReviews = event => {
      if (!event.target.closest('.jdgm-preview-badge')) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      const reviews = document.querySelector('.otd-product-reviews-section');
      if (!reviews) return;
      event.preventDefault();
      event.stopPropagation();
      reviews.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const heading = reviews.querySelector('h2');
      if (heading) { heading.tabIndex = -1; heading.focus({preventScroll: true}); }
    };
    product.addEventListener('click', openReviews, true);
    product.addEventListener('keydown', openReviews, true);

    // Empty asynchronous app blocks keep their mount points without adding gaps.
    const sizes = new ResizeObserver(entries => entries.forEach(({target, contentRect}) => {
      const space = contentRect.height > 0 ? '16px' : '0px';
      if (target.style.getPropertyValue('--otd-block-space') !== space) target.style.setProperty('--otd-block-space', space);
    }));
    Array.from(info.children).forEach(child => sizes.observe(child));
    const bar = product.querySelector('[data-otd-mobile-purchase]');
    const proxy = bar.querySelector('[data-otd-mobile-button]');
    const price = bar.querySelector('[data-otd-mobile-price]');
    let queued = false;
    const update = () => {
      queued = false;
      const submit = product.querySelector('[data-otd-purchase-block] button[name="add"]');
      if (!submit) { bar.hidden = true; return; }
      bar.hidden = !matchMedia('(max-width: 767px)').matches || submit.getBoundingClientRect().bottom >= 0;
      proxy.disabled = submit.disabled;
      const label = submit.querySelector('.js-product-form-submit-btn-text')?.textContent.trim() || 'Add to cart';
      if (proxy.textContent !== label) proxy.textContent = label;
      const amount = product.querySelector('.product__prices .price-item--sale') || product.querySelector('.product__prices .price-item--last') || product.querySelector('.product__prices .price');
      const value = amount?.textContent.trim() || '';
      if (price.textContent !== value) price.textContent = value;
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    proxy.addEventListener('click', () => {
      const submit = product.querySelector('[data-otd-purchase-block] button[name="add"]');
      if (submit && !submit.disabled) submit.click();
    });
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', schedule, {passive: true});
    const changes = new MutationObserver(schedule);
    changes.observe(info, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled']});
    product.addEventListener('change', schedule);
    update();
    product.otdCleanup = () => { product.removeEventListener('click', openReviews, true); product.removeEventListener('keydown', openReviews, true); sizes.disconnect(); changes.disconnect(); removeEventListener('scroll', schedule); removeEventListener('resize', schedule); };
  }
  function init() {
    document.querySelectorAll('.otd-product-page').forEach(enhanceProduct);
    enhanceDetails();
  }
  // Tidio mounts its panel in an open shadow root. Constrain its fixed-width
  // panel on phones so raising the launcher never clips the open chat.
  let chatAttempts = 0;
  function fitChatPanel() {
    const shadow = document.querySelector('#tidio-chat')?.shadowRoot;
    if (shadow) {
      if (!shadow.getElementById('otd-chat-fit')) {
        const style = document.createElement('style');
        style.id = 'otd-chat-fit';
        style.textContent = '@media(max-width:767px){#tidio-chat-root{max-width:calc(100% - 32px)!important;left:auto!important;right:16px!important;margin-inline:0!important;}#tidio-chat-root .chat{max-width:100%!important;}}';
        shadow.append(style);
      }
    } else if (++chatAttempts < 60) setTimeout(fitChatPanel, 250);
  }
  init();
  fitChatPanel();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('.otd-product-page')?.otdCleanup?.());
})();
